import { apiMemberserviceEndpoint } from '@/config/config.js'
import { createApiClient } from '@/services/baseservice.js'

const apiScope = 'api://memberservice-api/Member.Read'
const basePath = '/billings/member-type-correction-runs'
const api = createApiClient(apiScope, apiMemberserviceEndpoint)
const config = { baseURL: apiMemberserviceEndpoint }

export default {
  startRun(payload) {
    return api.post(basePath, payload, config)
  },
  getRun(runId) {
    return api.get(`${basePath}/${runId}`, config)
  },
  getPreview(runId, stepKey) {
    return api.get(`${basePath}/${runId}/steps/${stepKey}/preview`, config)
  },
  applyStep(runId, stepKey, payload) {
    return api.post(`${basePath}/${runId}/steps/${stepKey}/apply`, payload, config)
  },
  skipStep(runId, stepKey, payload) {
    return api.post(`${basePath}/${runId}/steps/${stepKey}/skip`, payload, config)
  },
  getSummary(runId) {
    return api.get(`${basePath}/${runId}/summary`, config)
  },
  createBilling() {
    return api.get('/billings', config)
  }
}
